export const THEME_COLOR_ACCENT = 'accentColor';
export const THEME_COLOR_BACKGROUND = 'backgroundColor';
export const THEME_COLOR_TEXT= 'textColor';
export const THEME_FONT = 'fontFamily';
export const THEME_LOGO = 'logo';
export const THEME_BACKGROUND_IMAGE = 'backgroundImage';
export const THEME_COLOR_THEME = 'colorTheme';
export const THEME_POSTER = 'poster';

export const THEME = 'theme';
export const THEME_DARK = 'dark';
export const THEME_LIGHT = 'light';

export const TYPE_SVG = 'image/svg+xml';
export const TYPE_JPG = 'image/jpeg';
export const TYPE_PNG = 'image/png';
export const TYPE_WEBP = 'image/webp';

export const SETTINGS_BACKGROUND_IMAGE = 'backgroundImage';
export const SETTINGS_POSTER_IMAGE = 'posterImage';
export const SETTINGS_HIDE_INFO_BLOCK = 'hideInfoBlock';

export const SETTINGS_EVENT_TITLE = 'eventTitle';
export const SETTINGS_EVENT_SUBTITLE = 'eventSubtitle';
export const SETTINGS_DATE = 'date';
export const SETTINGS_HIDE_EVENT_TITLE = 'hideEventTitle';
export const SETTINGS_HIDE_EVENT_SUBTITLE = 'hideEventSubtitle';
export const SETTINGS_HIDE_DATE = 'hideDate';
export const SETTINGS_HIDE_FORMAT = 'hideFormat';

export const SETTINGS_ENTER_ONLY = 'enterOnly';
export const SETTINGS_LOGIN_SUBTITLE = 'loginSubtitle';
export const SETTINGS_HIDE_LOGIN_SUBTITLE = 'hideLoginSubtitle';

export const SETTINGS_REGISTRATION_SUBTITLE = 'registrationSubtitle';
export const SETTINGS_HIDE_REGISTRATION_SUBTITLE = 'hideRegistrationSubtitle';

export const SETTINGS_SUCCESS_TITLE = 'successTitle';
export const SETTINGS_SUCCESS_SUBTITLE = 'successSubtitle';
export const SETTINGS_HIDE_SUCCESS_TITLE = 'hideSuccessTitle';
export const SETTINGS_HIDE_SUCCESS_SUBTITLE = 'hideSuccessSubtitle';

export const SETTINGS_ACCEPTED_TITLE = 'acceptedTitle';
export const SETTINGS_ACCEPTED_SUBTITLE = 'acceptedSubtitle';
export const SETTINGS_HIDE_ACCEPTED_TITLE = 'hideAcceptedTitle';
export const SETTINGS_HIDE_ACCEPTED_SUBTITLE = 'hideAcceptedSubtitle';

export const SETTINGS_HINT_BACKGROUND = `
    - Формат файла - .jpg, .png, .webp;
    - Минимальное рекомендуемое разрешение - 1024 на 768 пикселей;
`;

export const LOGIN_OPTION_INFO = 'infoBlock';
export const LOGIN_OPTION_EMAIL_REQUEST = 'emailRequest';
export const LOGIN_OPTION_REGISTRATION = 'registration';
export const LOGIN_OPTION_REGISTRATION_SUCCESS = 'registrationSuccess';
export const LOGIN_OPTION_REGISTRATION_PREMODERATION = 'registrationPremoderation';
export const LOGIN_OPTION_PARTICIPATION_TYPE_SELECT = 'participationTypeSelect';

export const TYPE_HYBRID = 'hybrid';
export const TYPE_ONLINE = 'online';
export const TYPE_OFFLINE = 'offline';

export const DEFAULT_CONFIRMATION_TITLE_PREMODERATION = (eventName) => ({
    ru: `Спасибо, ваша заявка на "${eventName}" принята!`,
    en: `Thank you, your application for "${eventName}" has been accepted!`,
});

export const DEFAULT_CONFIRMATION_TITLE_SUCCESS = (eventName) => ({
    ru: `Поздравляем, вы успешно зарегистрированы на мероприятие "${eventName}"!`,
    en: `Congratulations, you have successfully registered for the event "${eventName}"!`,
});

export const DEFAULT_CONFIRMATION_CONFIRMATION_PREMODERATION = {
    ru: 'После одобрения заявки организаторами мероприятия вы получите подтверждение участия на электронный адрес test@comdi.com, указанный в форме регистрации. Если вы не можете найти письмо, проверьте папку Спам или свяжитесь с поддержкой support@comdi.com.',
    en: 'After your application is approved by the event organizers, you will receive confirmation of participation to the test@comdi.com address specified in the registration form.If you cannot find the email, check your Spam folder or contact support@ comdi.com.',
};

export const DEFAULT_CONFIRMATION_TEXT_SUCCESS = {
    ru: 'Мы отправили вам на test@comdi.com подтверждение регистрации и письмо с одноразовым кодом для доступа к мероприятию прямо сейчас. Если вы не можете найти наши письма, проверьте папку "Спам" или свяжитесь с поддержкой support@comdi.com.',
    en: 'We have sent you a confirmation of registration to test@comdi.com and an email with a one-time code to access the event right now. If you cannot find our emails, please click on the Spam icon or contact support@comdi.com.',
};
